"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Alert = _interopRequireDefault(require("react-bootstrap/Alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * An Alert is a component that appears on screen when the user needs to be informed of something.
 */
const Alert = _ref => {
  let {
    children,
    compact,
    type,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Alert.default, _extends({
    variant: `${type}${compact ? '--compact' : ''}`,
    role: "alert",
    "aria-label": type
  }, rest), children);
};
var _default = exports.default = Alert;
Alert.propTypes = {
  /**
   * Alert message contents.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Compact alters the appearance of the alert to one without the block of color on the left side.
   */
  compact: _propTypes.default.bool,
  /**
   * Dismissible determines whether or not to show the close button on the side of the alert. When dismissible is false the user won't be able to close the alert.
   */
  dismissible: _propTypes.default.bool,
  /**
   * An optional callback method to add functionality for when the alert is closed.
   */
  onClose: _propTypes.default.func,
  /**
   * Determines whether or not to display the alert.
   */
  show: _propTypes.default.bool,
  /**
   * Control how the hide/show state should be displayed.
   */
  transition: _propTypes.default.bool,
  /**
   * Type alters the appearance and color of the alert. The type should be selected to match the context of the alert content.
   */
  type: _propTypes.default.oneOf(['info', 'danger', 'success', 'warning'])
};
Alert.defaultProps = {
  compact: false,
  dismissible: false,
  show: true,
  transition: false,
  type: 'info'
};